import * as ActionTypes from '../actions/actionTypes';
import {sortExtendedDataByDisplayName} from '../utils/point_utils';

const initialState = { details: null, extended_data: [] };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CLEAR_POINT_DETAILS:
      return initialState;

    case ActionTypes.SET_ACTIVE_POINT:
      return {
        ...state,
        point: action.point
      };

    case ActionTypes.POPULATE_POINT_PRIMARY_DETAILS:
      return {
        ...state,
        details: action.details
      };

    case ActionTypes.POPULATE_POINT_EXTENDED_DETAILS:
      return {
        ...state,
        extended_data: sortExtendedDataByDisplayName([...state.extended_data, ...action.extended_data])
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/popup_data.js